import './src/index.css'
import './src/i18n/i18n'
import React from 'react'
import { I18nextProvider } from 'react-i18next'
import i18n from './src/i18n/i18n'
import { ErrorBoundary } from './src/components/ErrorBoundary'
import { logError } from './src/utils/rollbar-client'

export const wrapRootElement = ({ element }) => {
  return (
    <I18nextProvider i18n={i18n}>
      <ErrorBoundary>
        {element}
      </ErrorBoundary>
    </I18nextProvider>
  )
}

export const onRouteUpdateDelayed = () => {
  logError('Route update delayed', {
    location: window.location.href,
    timestamp: new Date().toISOString(),
  })
}

export const onServiceWorkerUpdateReady = () => {
  logError('Service worker update ready', {
    location: window.location.href,
    timestamp: new Date().toISOString(),
  })
}
